var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlog3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "220 220 60 60",
    enableBackground: "new 220 220 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2C2C2C",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M253.1,270.4 c0,0,0-7.3,0-7.3c0-0.7-0.3-1.4-0.9-1.9c-0.9-0.8-1.7-0.8-2.7-0.9c-0.8,0-1.8,0.2-2.5,0.7c-0.7,0.5-1.1,1.3-1.1,2.1v7.3  M246.8,254.8l0-1.3c-0.4-1.5-1.7-2.5-3.3-2.5h-2.4c-1.9,0-3.4,1.5-3.4,3.4v12.5c0,0.2-0.2,0.3-0.3,0.3c-0.5,0-1.2-0.6-1.6-1 l-0.2-0.2c-0.7-0.6-1.3-1.3-1.8-1.9c-3.2-3.7-5-8.5-5-13.5c0-5.8,2.5-11.3,6.8-15.3c12.7-11.6,34.4-4.7,35.7,13.8 c0.4,6.3-2,12.4-6.7,16.7c-0.2,0.2-0.6,0.3-0.9,0.3c-0.2,0-0.4,0-0.5-0.1c-0.5-0.2-0.8-0.7-0.8-1.2v-13.9c0-2.2-1.8-4-4.1-4h-2.8 c-2.3,0-4.1,1.8-4.1,4v3.3 M249.6,253.4c-1.9,0-3.4,1.5-3.4,3.3c0,1.8,1.5,3.3,3.4,3.3c1.9,0,3.4-1.5,3.4-3.3 C252.9,254.9,251.4,253.4,249.6,253.4z M242.3,241.5c-2.4,0-4.4,1.9-4.4,4.3c0,2.4,2,4.3,4.4,4.3c1.2,0,2.3-0.4,3.1-1.3 c0.8-0.8,1.3-1.9,1.3-3C246.7,243.4,244.7,241.5,242.3,241.5z M256.8,235.7c-2.9,0-5.2,2.3-5.2,5.1c0,2.8,2.3,5.1,5.2,5.1 c2.9,0,5.2-2.3,5.2-5.1C262,238,259.6,235.7,256.8,235.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog3);
export default __webpack_public_path__ + "static/media/blog3.222a72ff11b5caca411a9f4db160ef95.svg";
export { ForwardRef as ReactComponent };